import { useDistanceFormatter } from 'i18n/unitFormat';
import { useOTSTranslation } from 'i18n/useOTSTranslation';
import { BlockHeader } from 'components/blocks/BlockHeader';
import { BlockContent } from 'components/blocks/BlockContent';
import { BoxWithShadow } from 'components/blocks/BoxWithShadow';
import { IconWTextBelow } from 'components/resort/IconWTextBelow';
import { hasRangeData } from 'util/isEmpty';
import { ReactComponent as SvgParks } from 'public/assets/icons/parks.svg';
import { ReactComponent as SvgPipes } from 'public/assets/icons/pipes.svg';
import { ReactComponent as SvgTubing } from 'public/assets/icons/tubing.non-compliant.svg';
import { IResortSnowReportTerrain } from 'api/resort/types';
import { ReactComponent as SvgOpenTotal } from '../../../../public/assets/icons/nordic-open.svg';
import { ReactComponent as SvgSkateGroomed } from '../../../../public/assets/icons/nordic-skate.svg';
import { ReactComponent as SvgTrackset } from '../../../../public/assets/icons/nordic-trackset.svg';
import styles from './styles.module.scss';

export const AdditionalActivities = ({ isFresh, data }: {
  isFresh: boolean, data?: IResortSnowReportTerrain
}) => {
  const { t } = useOTSTranslation('common');
  const unitT = useDistanceFormatter('kmOrMile');

  return (
    <BoxWithShadow>
      <BlockHeader useH3 title={t('resort.skiReport.activities')} />
      <BlockContent blur={!isFresh}>
        <div className={styles.box}>
          {
            hasRangeData(data?.parks)
            && (
              <IconWTextBelow
                Icon={SvgParks}
                text={`${data?.parks?.open ?? t('common.dash')}/${data?.parks?.total ?? t('common.dash')}`}
                bottom={t('resort.skiReport.parksOpen')}
                iconTitle={t('resort.skiReport.toolTipParks')}
              />
            )
          }
          {
            hasRangeData(data?.pipes)
            && (
              <IconWTextBelow
                Icon={SvgPipes}
                text={`${data?.pipes?.open ?? t('common.dash')}/${data?.pipes?.total ?? t('common.dash')}`}
                bottom={t('resort.skiReport.pipesOpen')}
                iconTitle={t('resort.skiReport.toolTipPipes')}
              />
            )
          }
          {
            hasRangeData(data?.tubes)
            && (
              <IconWTextBelow
                Icon={SvgTubing}
                text={`${data?.tubes?.open ?? t('common.dash')}/${data?.tubes?.total ?? t('common.dash')}`}
                bottom={t('resort.skiReport.tubingLanes')}
                iconTitle={t('resort.skiReport.tubingLanes')}
              />
            )
          }
          {
            !!(data?.nordic?.open)
            && (
              <IconWTextBelow
                Icon={SvgOpenTotal}
                text={unitT(data?.nordic?.open)}
                bottom={t('resort.skiReport.nordicOpen')}
                iconTitle={t('resort.skiReport.toolTipNordic')}
              />
            )
          }
          {
            !!(data?.nordic?.skategroomed)
            && (
              <IconWTextBelow
                Icon={SvgSkateGroomed}
                text={unitT(data?.nordic?.skategroomed)}
                bottom={t('resort.skiReport.nordicSkategroomed')}
                iconTitle={t('resort.skiReport.nordicSkategroomed')}
              />
            )
          }
          {
            !!(data?.nordic?.trackset)
            && (
              <IconWTextBelow
                Icon={SvgTrackset}
                text={unitT(data?.nordic?.trackset)}
                bottom={t('resort.skiReport.nordicTrackset')}
                iconTitle={t('resort.skiReport.nordicTrackset')}
              />
            )
          }
        </div>
      </BlockContent>
    </BoxWithShadow>
  );
};
